/**
 *  Italy specific form validation rules
 */
export const isPhoneNumber = (value: string): boolean => {
  return REGEX.PHONE_NUMBER.test(value)
}

export const isMobilePhoneNumber = (value: string): boolean => {
  return REGEX.MOBILE_PHONE_NUMBER.test(value)
}

export const isPostalCode = (value: string): boolean => {
  return REGEX.POSTAL_CODE.test(value)
}

const REGEX = {
  MOBILE_PHONE_NUMBER: /^\+?[0-9]{8,12}$/,
  // Danish PhoneNumbers: from 8 to 12 numbers '+(optional)1234567890'
  PHONE_NUMBER: /^\+?[0-9]{8,12}$/,
  // Danish PhoneNumbers: from 8 to 12 numbers '+(optional)1234567890'
  POSTAL_CODE: /^\d{2}[ ]?\d{2}$/,
  // Danish Postal Codes are 4 digits: 4444
}

// Swedish check:
// MOBILE_PHONE_NUMBER: /^(\+467|07)[0-9]{8}$/,
// PHONE_NUMBER: /^(\+46|0)[0-9]{6,12}$/,
// POSTAL_CODE: /^\d{3}[ ]?\d{2}$/,
